import { c as _c } from "react/compiler-runtime";
import { useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { captureDomToPdf, type DomToPdfOptions } from '@/utils/dom-to-pdf';
const usePdfCapture = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "components.pdfExport"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const {
    toast
  } = useToast();
  let t1;
  if ($[1] !== t || $[2] !== toast) {
    t1 = async (el, options) => {
      try {
        await captureDomToPdf(el, options);
      } catch {
        toast({
          variant: "error",
          title: t(_temp),
          description: t(_temp2)
        });
      }
    };
    $[1] = t;
    $[2] = toast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const capturePdf = t1;
  return capturePdf;
};
export default usePdfCapture;
function _temp($) {
  return $.errorToast.title;
}
function _temp2($_0) {
  return $_0.errorToast.description;
}